import React, { FC, useState } from "react";
import {
  Table,
  Menu,
  Button,
  Dropdown,
  Popconfirm,
  TablePaginationConfig,
} from "antd";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import getColumnSearchProps from "../Layout/Common/Adapters/TableFilter";
import useHttpGet from "../../hooks/useHttpGet";
import { IResultResponse } from "../../models/response/result.model";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import IndicesService from "../../services/indices.service";
import { ICryptoIndex } from "../../models/cryptoindex.model";
import { PrivateUIRoutes } from "../../router";
import { GetRecordState, RecordState } from "../../services/enums";

const List: FC = () => {
  const [filter, setFilter] = useState({
    search: null,
    sortPropertyName: "sortNumber",
    sortAscending: true,
  });

  const [pagination, setPagination] = useState<any>({
    showSizeChanger: true,
    pageSizeOptions: ["30", "50", "100"],
    defaultPageSize: 30,
    pageSize: 30,
    current: 1,
    total: 1,
  });

  let { fetchedData, loading } = useHttpGet<IResultResponse<ICryptoIndex[]>>(
    `${APIRoutes.CRYPTO_INDEX}`,
    {
      dependencies: [filter],
      query: {
        ...filter,
        pageSize: pagination.pageSize,
        pageNumber: pagination.current - 1,
      },
      defaultValue: {} as IResultResponse<ICryptoIndex[]>,
      reject: CommonService.showAllErrors,
    }
  );

  const handleTableChange = (
    newPagination: TablePaginationConfig,
    filters: any,
    sorter: any
  ) => {
    setPagination({ ...pagination, ...newPagination });

    const newFilter: any = { ...filter };

    newFilter.search = filters?.name?.length > 0 ? filters?.name[0] : null;

    if (!!sorter) {
      newFilter.sortPropertyName = sorter.field;
      newFilter.sortAscending = sorter?.order === "ascend";
    }

    setFilter(newFilter);
  };

  const handleStateChange = (index: ICryptoIndex) => {
    if (index.state === RecordState.Active) {
      IndicesService.archive(index.id);
    } else {
      IndicesService.restore(index.id);
    }
  };

  const menu = (record: ICryptoIndex) => (
    <Menu>
      <Menu.Item key="1">
        <Link
          className="c-blue"
          to={`/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.EDIT_INDICES_BASE}/${record?.id}`}
        >
          Edit
        </Link>
      </Menu.Item>

      <Menu.Item key="2">
        <Popconfirm
          title={`Are you sure you want to ${record.state === RecordState.Archived ? 'restore' : 'archive'} this item?`}
          onConfirm={() => handleStateChange(record)}
          onCancel={() => { }}
          okText="Yes"
          cancelText="No"
        >
          {record.state === RecordState.Archived ? 'Restore' : 'Archive'}
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
    },
    {
      title: "Name",
      dataIndex: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Ticker",
      dataIndex: "ticker",
    },
    {
      title: "State",
      dataIndex: "state",
      render: (text: any, record: ICryptoIndex) => {
        return (<>{GetRecordState(record.state)}</>);
      }
    },
    {
      title: "",
      dataIndex: "id",
      render: (text: any, record: ICryptoIndex) => {
        return (
          <Dropdown overlay={menu(record)}>
            <Button>
              <MenuOutlined />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <Table
      size="small"
      columns={columns}
      dataSource={fetchedData.result}
      onChange={handleTableChange}
      pagination={pagination}
      rowKey="id"
      loading={loading}
    />
  );
};

export default List;
